import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "14 2 14 8 20 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "16", x2: "8", y1: "13", y2: "13", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "16", x2: "8", y1: "17", y2: "17", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "10", x2: "8", y1: "9", y2: "9", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileText";
const FileText = memo(themed(Icon));
export {
  FileText
};
//# sourceMappingURL=file-text.js.map
